import { useState, useEffect } from 'react';
import ConversationService from '../services/ConversationService';
function useDashboards(id) {
    const [markers, setMarkers] = useState(null);
    const { getMarkers } = ConversationService;
    async function setUpMarkers() {
        const [response, errors] = await getMarkers(id)
        if (errors != null) {
            console.log(errors)
            return;
        }
        setMarkers(response);
    }

    useEffect(() => {
        setUpMarkers();
    }, []);

    return { markers, setMarkers };
}

export default useDashboards;